export const SWAP_FEE = 0.0125;

interface DisplayOptions {
  showLogoTopLeft: boolean;
  showCompanyNameTopLeft: boolean;
  showProjectNameTopLeft: boolean;
  showLinksInHeader: boolean;
  showPrimaryDescription: boolean;
  showSecondaryDescription: boolean;
  showBackgroundImage: boolean;
}

interface HeaderLink {
  name: string;
  url: string;
}

interface Socials {
  website: string;
  twitter?: string;
  telegram?: string;
  discord?: string;
  youtube?: string;
  reddit?: string;
}

interface PresaleInstructions {
  stepNumber: number;
  action: string;
  description: string;
  icon: string;
}

interface PresaleDetails {
  minContribution: string;
  maxContribution: string;
  presaleStatus: string;
  affiliateId: number;
  chainName: string;
  token: string;
  hasHardcap: boolean;
}

interface Config {
  siteTitle: string;
  siteDescription: string;
  companyName: string;
  projectName?: string;
  primaryDescription?: string;
  secondaryDescription?: string;
  displayOptions?: DisplayOptions;
  logoLinksSomewhere: boolean;
  linksInHeader: HeaderLink[];
  socials: Socials;
  moonpay?: { buyUrl?: string; sellUrl?: string };
  logoPath: string;
  logoWidth: number;
  logoHeight: number;
  backgroundImagePath?: string;
  backgroundImageOpacity: number;
  presaleInstructions: PresaleInstructions[];
  presaleDetails: PresaleDetails;
}

// set values for config here
const config: Config = {
  siteTitle: "ForgeSwap",
  siteDescription:
    "ForgeSwap is a decentralized trading platform giving our users the ability to Swap between 30+ blockchains. Integrations such as direct purchase with your bank card, creating a wallet with your email, and our affiliate marketing integration adds extreme benefit to both investors and DeFi projects.",
  companyName: "ForgeSwap",
  projectName: "ForgeSwap",
  primaryDescription: "",
  // secondaryDescription: "Default Secondary Description",
  displayOptions: {
    showLogoTopLeft: true,
    showCompanyNameTopLeft: false, // note: only showCompanyNameTopLeft or showProjectNameTopLeft should be true
    showProjectNameTopLeft: false,
    showLinksInHeader: true,
    showPrimaryDescription: true,
    showSecondaryDescription: true,
    showBackgroundImage: false,
  },
  logoLinksSomewhere: false,
  linksInHeader: [
    {
      name: "Staking",
      url: "https://www.stake.prevailtoken.com/",
    },
    {
      name: "Mint",
      url: "https://mint.prevailtoken.com/",
    },
  ],
  socials: {
    website: "https://forgeswap.fun",
    twitter: "https://x.com/ForgeSwapApp",
    telegram: "https://t.me/ForgeEcoSystem",
    discord: "https://discord.gg/tnHqHa8uY",
  },
  moonpay: {
    // Replace with your tracked referral URLs from MoonPay to receive fees
    buyUrl: process.env.NEXT_PUBLIC_MOONPAY_BUY_URL,
    sellUrl: process.env.NEXT_PUBLIC_MOONPAY_SELL_URL,
  },
  logoPath: "/logo.png",
  logoWidth: 50,
  logoHeight: 50,
  backgroundImagePath: "/brand-bg.jpg",
  backgroundImageOpacity: 50, // 0 - 100 (increments of 5)
  presaleInstructions: [
    {
      stepNumber: 1,
      action: "Connect",
      description: "Connect your wallet and enter an amount to contribute.",
      icon: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244",
    },
    {
      stepNumber: 2,
      action: "Contribute",
      description:
        "Enter the amount you want to contribute and click 'Contribute'.",
      icon: "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9",
    },
    {
      stepNumber: 3,
      action: "Confirm",
      description:
        "Confirm The Transaction To Secure Your Spot In The Presale.",
      icon: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
    },
  ],
  presaleDetails: {
    minContribution: "0.1 ETH",
    maxContribution: "1 ETH",
    presaleStatus: "Live", // "Upcoming" | "Live" | "Ended"
    affiliateId: 0,
    chainName: "Ethereum",
    token: "ETH",
    hasHardcap: true, // when true, replace maxContribution with hardcap
  },
};

export default config;
